import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { ERoutes } from 'src/app/core/enums/routes.enum';
import { EInfoType } from 'src/app/core/enums/country-info-type.enum';
import { ReplaceStrPipe } from 'src/app/shared/pipes/replace-str.pipe';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

import { ItineraryCardMobileComponent } from '../itinerary-card-mobile/itinerary-card-mobile.component';

import { SwiperOptions } from 'swiper/types/swiper-options';

const ITINERARY_LIST_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoplay: false,
  breakpoints: {
    375: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    524: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1100: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-itinerary-list-mobile',
  templateUrl: './itinerary-list-mobile.component.html',
  styleUrls: ['itinerary-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    TitleCasePipe,
    ReplaceStrPipe,
    SwiperDirective,
    ItineraryCardMobileComponent,
  ],
})
export class ItineraryListMobileComponent {
  @Input() title: string = '';
  @Input() isFetching: boolean = false;
  @Input() countryName: string = '';
  @Input() itineraries: any[] = [];
  @Output() onSeeAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() makeItMyPlan: EventEmitter<void> = new EventEmitter<void>();

  protected readonly eInfoType = EInfoType;
  protected isVerticalWrapper: boolean = false;
  protected swiperOptions: SwiperOptions = ITINERARY_LIST_SWIPER_OPTIONS;

  readonly #router = inject(Router);

  @Input() set isVertical(value: boolean) {
    if (value) {
      this.isVerticalWrapper = true;
      this.swiperOptions = {
        ...ITINERARY_LIST_SWIPER_OPTIONS,
        direction: 'vertical',
        autoplay: false,
        freeMode: true,
        breakpoints: {
          375: {
            slidesPerView: 'auto',
            spaceBetween: 16,
          },
          768: {
            spaceBetween: 24,
          },
        },
      };
    }
  }

  public seeAll(e: MouseEvent): void {
    e.preventDefault();
    this.onSeeAll.emit();
  }

  public onMakeItMyTripPlanHandler(topTripUrl: string): void {
    this.#router
      .navigate([ERoutes.SLASH, ERoutes.TRIP_PLANNER, topTripUrl])
      .then(() => this.makeItMyPlan.emit());
  }
}
